var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mds-row',[_c('store-provider',_vm._b({attrs:{"params":{ companyId: _vm.$route.params.id }},scopedSlots:_vm._u([{key:"default",fn:function({ state: providers }){return [_c('provider-form',{attrs:{"providers":providers,"is-new":!_vm.$route.params.id}})]}}])},'store-provider',_vm.$options.storeInfo,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }